/* eslint-disable prefer-destructuring */
import { useRouter } from 'next/dist/client/router';
import client from 'graphql/client';
import { GET_PAGE_BY_SLUG } from 'graphql/queries';
import PlansTemplate from 'templates/PlansTemplate';

import { fetchPlans } from 'services/subscriptionService';

export default function Page(props) {
  const router = useRouter();

  if (router.isFallback) return null;

  return <PlansTemplate {...props} />;
}

export const getServerSideProps = async ({ query }) => {
  const slug = query?.slug;
  const params = { trial: query?.cp, identifier: slug };

  const { newPlans: page } = await client.request(GET_PAGE_BY_SLUG, {
    slug: `${slug}`,
  });

  if (!page) return { notFound: true };

  return { props: { ...page, plans: await fetchPlans(params) } };
};
